<template>
  <span :title="$_.get(user, 'name')">
    <template v-if="$_.get(user, 'name')">{{ $_.get(user, "name") }}</template>
    <template v-else>{{ $_.get(user, "email") }}</template>
  </span>
</template>

<script>
export default {
  props: {
    user: {
      type: Object
    }
  }
}
</script>